import { List } from 'immutable';
import { Job } from './job.model';
import { IErrorPayload } from '../review-data/review-data.actions';
import { JobPortalData } from './models/job-portal-data.model';
import { JobEstimate } from './models/submodels/job-estimate.model';
import { Attachments } from './models/submodels/attachments.model';
import { JobNote } from './models/submodels/job-note.model';

export enum ActionsEnum {
  FETCH_JOBS = '[job] FETCH_JOBS',
  FETCH_JOBS_SUCCESS = '[job] FETCH_JOBS_SUCCESS',
  FETCH_JOBS_ERROR = '[job] FETCH_JOBS_ERROR',

  FETCH_JOB_PORTAL_DATA = '[job] FETCH_JOB_PORTAL_DATA',
  FETCH_JOB_PORTAL_DATA_SUCCESS = '[job] FETCH_JOB_PORTAL_DATA_SUCCESS',
  FETCH_JOB_PORTAL_DATA_ERROR = '[job] FETCH_JOB_PORTAL_DATA_ERROR',

  CREATE_JOB = '[job] CREATE_JOB',
  CREATE_JOB_SUCCESS = '[job] CREATE_JOB_SUCCESS',
  CREATE_JOB_ERROR = '[job] CREATE_JOB_ERROR',

  ADD_ESTIMATE = '[job] ADD_ESTIMATE',
  ADD_ESTIMATE_SUCCESS = '[job] ADD_ESTIMATE_SUCCESS',
  ADD_ESTIMATE_ERROR = '[job] ADD_ESTIMATE_ERROR',

  APPROVE_ESTIMATE = '[job] APPROVE_ESTIMATE',
  APPROVE_ESTIMATE_SUCCESS = '[job] APPROVE_ESTIMATE_SUCCESS',
  APPROVE_ESTIMATE_ERROR = '[job] APPROVE_ESTIMATE_ERROR',

  FETCH_ATTACHMENT = '[job] FETCH_ATTACHMENT',
  FETCH_ATTACHMENT_SUCCESS = '[job] FETCH_ATTACHMENT_SUCCESS',
  FETCH_ATTACHMENT_ERROR = '[job] FETCH_ATTACHMENT_ERROR',

  DELETE_ATTACHMENT = '[job] DELETE_ATTACHMENT',
  DELETE_ATTACHMENT_SUCCESS = '[job] DELETE_ATTACHMENT_SUCCESS',
  DELETE_ATTACHMENT_ERROR = '[job] DELETE_ATTACHMENT_ERROR',

  DELETE_ESTIMATE = '[job] DELETE_ESTIMATE',
  DELETE_ESTIMATE_SUCCESS = '[job] DELETE_ESTIMATE_SUCCESS',
  DELETE_ESTIMATE_ERROR = '[job] DELETE_ESTIMATE_ERROR',

  SET_ESTIMATE_PREVIEW = '[job] SET_ESTIMATE_PREVIEW',
  SET_ATTACHMENT_PREVIEW = '[job] SET_ATTACHMENT_PREVIEW',
  NAVIGATE_TO_ESTIMATE_CREATION = '[job] NAVIGATE_TO_ESTIMATE_CREATION',

  ADD_ATTACHMENT_SUCCESS = '[job] ADD_ATTACHMENT_SUCCESS',
  ADD_ATTACHMENT_ERROR = '[job] ADD_ATTACHMENT_ERROR',

  SAVE_NOTE = '[job] SAVE_NOTE',
  SAVE_NOTE_SUCCESS = '[job] SAVE_NOTE_SUCCESS',

  SAVE_EDITING_NOTE = '[job] SAVE_EDITING_NOTE',
  CONVERT_TO_INVOICE = '[job] CONVERT_TO_INVOICE',

  // TODO[job]: refactor other errors action to use this one
  ACTION_ERROR = '[job] ACTION_ERROR',
}

// action payloads
export interface IFetchJobsPayload {
  clientId: string;
}

export interface IFetchJobsSuccessPayload {
  jobs: List<Job>;
}

export interface ICreateJobPayload {
  clientId: string;
}

export interface ICreateJobSuccessPayload {
  job: Job;
}

export interface IFetchJobDetailPayload {
  jobId: string;
}

export interface IFetchJobDetailSuccessPayload {
  jobPortalData: JobPortalData;
}

export interface IAddEstimatePayload {
  jobId: string;
  documentId: string;
}

export interface IAddEstimateSuccessPayload {
  estimate: JobEstimate;
}

export interface IApproveEstimatePayload {
  documentId: string;
}

export interface IApproveEstimateSuccessPayload {
  documentId: string;
  approvalDate: string;
}

export interface IDeleteAttachmentPayload {
  attachmentId: string;
  jobId: string;
}

export interface IDeleteAttachmentSuccessPayload {
  attachment: Attachments;
}

export interface ISetEstimatePreviewPayload {
  documentId: string;
}

export interface ISetAttachmentPreviewPayload {
  attachment: Attachments;
}

export interface INavigateToEstimateCreationPayload {
  clientId: string;
  jobId: string;
}

export interface IDeleteEstimatePayload {
  documentId: string;
  jobId: string;
}

export interface IDeleteEstimateSuccessPayload {
  estimate: JobEstimate;
}

export interface IFetchAttachmentPayload {
  jobId: string;
  attachmentId: string;
}

export interface IFetchAttachmentSuccessPayload {
  attachment: Attachments;
}

export interface IAddAttachmentSuccessPayload {
  attachment: Attachments;
}

export interface IAddAttachmentErrorPayload {
  error: Error;
}

export interface ISaveNotePayload {
  content: string;
  jobId: string;
}

export interface ISaveNoteSuccessPayload {
  note: JobNote;
}

export interface ISaveNoteErrorPayload {
  error: Error;
}

export interface IConvertToInvoicePayload {
  documentId: string;
  jobId: string;
  clientId: string;
}

export interface IActionErrorPayload {
  error: Error;
}

// action definitions
export interface IFetchJobs {
  type: ActionsEnum.FETCH_JOBS;
  payload: IFetchJobsPayload;
}

export interface IFetchJobsSuccess {
  type: ActionsEnum.FETCH_JOBS_SUCCESS;
  payload: IFetchJobsSuccessPayload;
}

export interface IFetchJobsError {
  type: ActionsEnum.FETCH_JOBS_ERROR;
  payload: IErrorPayload;
}

export interface ICreateJob {
  type: ActionsEnum.CREATE_JOB;
  payload: ICreateJobPayload;
}

export interface ICreateJobSuccess {
  type: ActionsEnum.CREATE_JOB_SUCCESS;
  payload: ICreateJobSuccessPayload;
}

export interface ICreateJobError {
  type: ActionsEnum.CREATE_JOB_ERROR;
  payload: IErrorPayload;
}

export interface IFetchJobPortalData {
  type: ActionsEnum.FETCH_JOB_PORTAL_DATA;
  payload: IFetchJobDetailPayload;
}

export interface IFetchJobPortalDataSuccess {
  type: ActionsEnum.FETCH_JOB_PORTAL_DATA_SUCCESS;
  payload: IFetchJobDetailSuccessPayload;
}

export interface IFetchJobPortalDataError {
  type: ActionsEnum.FETCH_JOB_PORTAL_DATA_ERROR;
  payload: IErrorPayload;
}

export interface ICreateJobSuccess {
  type: ActionsEnum.CREATE_JOB_SUCCESS;
  payload: ICreateJobSuccessPayload;
}

export interface ICreateJobError {
  type: ActionsEnum.CREATE_JOB_ERROR;
  payload: IErrorPayload;
}

export interface IAddEstimate {
  type: ActionsEnum.ADD_ESTIMATE;
  payload: IAddEstimatePayload;
}

export interface IAddEstimateSuccess {
  type: ActionsEnum.ADD_ESTIMATE_SUCCESS;
  payload: IAddEstimateSuccessPayload;
}

export interface IAddEstimateError {
  type: ActionsEnum.ADD_ESTIMATE_ERROR;
  payload: IErrorPayload;
}

export interface IDeleteAttachment {
  type: ActionsEnum.DELETE_ATTACHMENT;
  payload: IDeleteAttachmentPayload;
}

export interface IDeleteAttachmentSuccess {
  type: ActionsEnum.DELETE_ATTACHMENT_SUCCESS;
  payload: IDeleteAttachmentSuccessPayload;
}

export interface IDeleteAttachmentError {
  type: ActionsEnum.DELETE_ATTACHMENT_ERROR;
  payload: IErrorPayload;
}

export interface IApproveEstimate {
  type: ActionsEnum.APPROVE_ESTIMATE;
  payload: IApproveEstimatePayload;
}

export interface IApproveEstimateSuccess {
  type: ActionsEnum.APPROVE_ESTIMATE_SUCCESS;
  payload: IApproveEstimateSuccessPayload;
}

export interface IApproveEstimateError {
  type: ActionsEnum.APPROVE_ESTIMATE_ERROR;
  payload: IErrorPayload;
}

export interface ISetEstimatePreview {
  type: ActionsEnum.SET_ESTIMATE_PREVIEW;
  payload: ISetEstimatePreviewPayload;
}

export interface ISetAttachmentPreview {
  type: ActionsEnum.SET_ATTACHMENT_PREVIEW;
  payload: ISetAttachmentPreviewPayload;
}

export interface INavigateToEstimateCreation {
  type: ActionsEnum.NAVIGATE_TO_ESTIMATE_CREATION;
  payload: INavigateToEstimateCreationPayload;
}

export interface IDeleteEstimate {
  type: ActionsEnum.DELETE_ESTIMATE;
  payload: IDeleteEstimatePayload;
}

export interface IDeleteEstimateSuccess {
  type: ActionsEnum.DELETE_ESTIMATE_SUCCESS;
  payload: IDeleteEstimateSuccessPayload;
}

export interface IDeleteEstimateError {
  type: ActionsEnum.DELETE_ESTIMATE_ERROR;
  payload: IErrorPayload;
}

export interface IFetchAttachment {
  type: ActionsEnum.FETCH_ATTACHMENT;
  payload: IFetchAttachmentPayload;
}

export interface IFetchAttachmentSuccess {
  type: ActionsEnum.FETCH_ATTACHMENT_SUCCESS;
  payload: IFetchAttachmentSuccessPayload;
}

export interface IFetchAttachmentError {
  type: ActionsEnum.FETCH_ATTACHMENT_ERROR;
  payload: IErrorPayload;
}

export interface IAddAttachmentSuccess {
  type: ActionsEnum.ADD_ATTACHMENT_SUCCESS;
  payload: IAddAttachmentSuccessPayload;
}

export interface IAddAttachmentError {
  type: ActionsEnum.ADD_ATTACHMENT_ERROR;
  payload: IAddAttachmentErrorPayload;
}

export interface ISaveNote {
  type: ActionsEnum.SAVE_NOTE;
  payload: ISaveNotePayload;
}

export interface ISaveNoteSuccess {
  type: ActionsEnum.SAVE_NOTE_SUCCESS;
  payload: ISaveNoteSuccessPayload;
}

export interface IConvertToInvoice {
  type: ActionsEnum.CONVERT_TO_INVOICE;
  payload: IConvertToInvoicePayload;
}

export interface IActionError {
  type: ActionsEnum.ACTION_ERROR;
  payload: IActionErrorPayload;
}

// action creators
export const fetchJobs = (clientId: string): IFetchJobs => ({
  type: ActionsEnum.FETCH_JOBS,
  payload: {
    clientId,
  },
});

export const fetchJobsSuccess = (jobs: List<Job>): IFetchJobsSuccess => ({
  type: ActionsEnum.FETCH_JOBS_SUCCESS,
  payload: {
    jobs,
  },
});

export const fetchJobsError = (error: Error): IFetchJobsError => ({
  type: ActionsEnum.FETCH_JOBS_ERROR,
  payload: {
    error,
  },
});

export const createJob = (clientId: string): ICreateJob => ({
  type: ActionsEnum.CREATE_JOB,
  payload: {
    clientId,
  },
});

export const createJobSuccess = (job: Job): ICreateJobSuccess => ({
  type: ActionsEnum.CREATE_JOB_SUCCESS,
  payload: {
    job,
  },
});

export const createJobError = (error: Error): ICreateJobError => ({
  type: ActionsEnum.CREATE_JOB_ERROR,
  payload: {
    error,
  },
});

export const fetchJobPortalData = (jobId: string): IFetchJobPortalData => ({
  type: ActionsEnum.FETCH_JOB_PORTAL_DATA,
  payload: {
    jobId,
  },
});

export const fetchJobPortalDataSuccess = (
  jobPortalData: JobPortalData
): IFetchJobPortalDataSuccess => ({
  type: ActionsEnum.FETCH_JOB_PORTAL_DATA_SUCCESS,
  payload: {
    jobPortalData,
  },
});

export const fetchJobPortalDataError = (
  error: Error
): IFetchJobPortalDataError => ({
  type: ActionsEnum.FETCH_JOB_PORTAL_DATA_ERROR,
  payload: {
    error,
  },
});

export const addEstimate = (
  documentId: string,
  jobId: string
): IAddEstimate => ({
  type: ActionsEnum.ADD_ESTIMATE,
  payload: {
    jobId,
    documentId,
  },
});

export const addEstimateSuccess = (
  estimate: JobEstimate
): IAddEstimateSuccess => ({
  type: ActionsEnum.ADD_ESTIMATE_SUCCESS,
  payload: {
    estimate,
  },
});

export const addEstimateError = (error: Error): IAddEstimateError => ({
  type: ActionsEnum.ADD_ESTIMATE_ERROR,
  payload: {
    error,
  },
});

export const approveEstimate = (documentId: string): IApproveEstimate => ({
  type: ActionsEnum.APPROVE_ESTIMATE,
  payload: {
    documentId,
  },
});

export const approveEstimateSuccess = (
  documentId: string,
  approvalDate: string
): IApproveEstimateSuccess => ({
  type: ActionsEnum.APPROVE_ESTIMATE_SUCCESS,
  payload: {
    documentId,
    approvalDate,
  },
});

export const approveEstimateError = (error: Error): IApproveEstimateError => ({
  type: ActionsEnum.APPROVE_ESTIMATE_ERROR,
  payload: {
    error,
  },
});

export const deleteAttachment = (
  attachmentId: string,
  jobId: string
): IDeleteAttachment => ({
  type: ActionsEnum.DELETE_ATTACHMENT,
  payload: {
    attachmentId,
    jobId,
  },
});

export const deleteAttachmentSuccess = (
  attachment: Attachments
): IDeleteAttachmentSuccess => ({
  type: ActionsEnum.DELETE_ATTACHMENT_SUCCESS,
  payload: {
    attachment,
  },
});

export const deleteAttachmentError = (
  error: Error
): IDeleteAttachmentError => ({
  type: ActionsEnum.DELETE_ATTACHMENT_ERROR,
  payload: {
    error,
  },
});

export const setEstimatePreview = (
  documentId: string
): ISetEstimatePreview => ({
  type: ActionsEnum.SET_ESTIMATE_PREVIEW,
  payload: {
    documentId,
  },
});

export const setAttachmentPreview = (
  attachment: Attachments
): ISetAttachmentPreview => ({
  type: ActionsEnum.SET_ATTACHMENT_PREVIEW,
  payload: {
    attachment,
  },
});

export const navigateToEstimateCreation = (
  clientId: string,
  jobId: string
): INavigateToEstimateCreation => ({
  type: ActionsEnum.NAVIGATE_TO_ESTIMATE_CREATION,
  payload: {
    clientId,
    jobId,
  },
});

export const deleteEstimate = (
  documentId: string,
  jobId: string
): IDeleteEstimate => ({
  type: ActionsEnum.DELETE_ESTIMATE,
  payload: {
    documentId,
    jobId,
  },
});

export const deleteEstimateSuccess = (
  estimate: JobEstimate
): IDeleteEstimateSuccess => ({
  type: ActionsEnum.DELETE_ESTIMATE_SUCCESS,
  payload: {
    estimate,
  },
});

export const deleteEstimateError = (error: Error): IDeleteEstimateError => ({
  type: ActionsEnum.DELETE_ESTIMATE_ERROR,
  payload: {
    error,
  },
});

export const fetchAttachment = (
  attachmentId: string,
  jobId: string
): IFetchAttachment => ({
  type: ActionsEnum.FETCH_ATTACHMENT,
  payload: {
    attachmentId,
    jobId,
  },
});

export const fetchAttachmentSuccess = (
  attachment: Attachments
): IFetchAttachmentSuccess => ({
  type: ActionsEnum.FETCH_ATTACHMENT_SUCCESS,
  payload: {
    attachment,
  },
});

export const fetchAttachmentError = (error: Error): IFetchAttachmentError => ({
  type: ActionsEnum.FETCH_ATTACHMENT_ERROR,
  payload: {
    error,
  },
});

export const addAttachmentSuccess = (
  attachment: Attachments
): IAddAttachmentSuccess => ({
  type: ActionsEnum.ADD_ATTACHMENT_SUCCESS,
  payload: {
    attachment,
  },
});

export const addAttachmentError = (error: Error): IAddAttachmentError => ({
  type: ActionsEnum.ADD_ATTACHMENT_ERROR,
  payload: {
    error,
  },
});

export const saveNote = (content: string, jobId: string): ISaveNote => ({
  type: ActionsEnum.SAVE_NOTE,
  payload: {
    content,
    jobId,
  },
});

export const saveNoteSuccess = (note: JobNote): ISaveNoteSuccess => ({
  type: ActionsEnum.SAVE_NOTE_SUCCESS,
  payload: {
    note,
  },
});

export const convertToInvoice = (
  documentId: string,
  jobId: string,
  clientId: string
): IConvertToInvoice => ({
  type: ActionsEnum.CONVERT_TO_INVOICE,
  payload: {
    documentId,
    jobId,
    clientId,
  },
});

export const actionError = (error: Error): IActionError => ({
  type: ActionsEnum.ACTION_ERROR,
  payload: {
    error,
  },
});
